import modalActions from "actions/modal";
import { connect } from "helpers/redux";
import { FC } from "react";
import { Action, ActionFunctionAny } from "redux-actions";

export default function (Component: FC) {
    const mapDispatch = (dispatch: ActionFunctionAny<Action<Object>>) => ({
        modal: (params: {}) => dispatch(modalActions.open(params)),
    });

    return connect(() => ({}), mapDispatch)(Component);
}
